import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Contact from '../components/Contact';
import Sponsors from '../components/Sponsors';

const ContactGeneral = () => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    fetch('https://la-leyenda.com/series/api/sponsors/cali')
    .then(res => res.json())
    .then(
      (res) => {
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  return (
    <Layout>
      <Banner id={63} city="contact-us" thumb="logo_adventures.png"/>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1>CONTÁCTANOS</h1>
          </div>
        </div>
        <Contact city="adventures" />
      </div>
      <Sponsors
        items={sponsors}
      />
    </Layout>
  );
}

export default ContactGeneral;
